import CartItem from '@/classes/CartObject';

class SkiSchoolCartItem extends CartItem {
  type = 'SKISCHOOL';

  name = '';

  pool_lid = ''; // eslint-disable-line
  activity_lid = ''; // eslint-disable-line
  people = [];

  site = null;
  date = null;
  time = null;

  days = 0;

  guardian = '';
  phone = '';

  constructor() {
    super();
    return true;
  }
}

export default SkiSchoolCartItem;



// WEBPACK FOOTER //
// ./src/classes/SkiSchoolCartItem.js